import { render, staticRenderFns } from "./ExtinguisherView.vue?vue&type=template&id=53543b92&"
import script from "./ExtinguisherView.vue?vue&type=script&lang=js&"
export * from "./ExtinguisherView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports